module.exports = __webpack_public_path__ + "img/event_execute.b34e5aeb.png";